import { styled } from '@clickcease/cc-client-components-lib'

export const BillingStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginTop: '$10',
})

export const BillingSectionTitleRow = styled('div', {
  display: 'flex',
  marginTop: '$3',
  marginBottom: '$3',
})

export const BillingSectionEdit = styled('div', {
  color: '$primaryColor',
  marginLeft: '$4',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  fontWeight: '$r',
  fontSize: '$md',
  paddingTop: '$1',
})

export const BillingSectionTitle = styled('div', {
  fontWeight: '$rb',
  fontSize: '$lg',
  variants: {
    noCard: {
      true: {
        marginBottom: '25px',
      },
    },
  },
})

export const LastThreeInvoices = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '$20',
})

export const BillingDetails = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const BillingDetailsTextWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  color: '$mainTextColor',
  fontSize: '$md',
  fontWeight: '$l',
  marginTop: '$3',
  lineHeight: '1.4rem',
})

export const BillingDetailsRow = styled('div', {})

export const BillingWireTransfer = styled('div', {
  display: 'flex',
  fontSize: '$md',
  marginBottom: '$2',
})
export const BillingWireTransferTitle = styled('div', {
  display: 'flex',
  fontSize: '$md',
  fontWeight: '$sb',
  marginTop: '$4',
  marginBottom: '$2',
})

export const BillingWireTransferStatus = styled('span', {
  display: 'flex',
  fontWeight: '$l',
  fontSize: '$md',
  marginBottom: '$2',
  color: '$color',
})

export const RectangleStatus = styled('span', {
  marginLeft: '$3',
  paddingRight: '$4',
  fontSize: '$sm',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '$normal',
  backgroundColor: '$color',
  '@laptop': {
    padding: '$1 $2',
  },
})
